import { videoLabel, type VideoIdentity } from "@meta-video/contracts";
import { useState, type ReactNode } from "react";

export function VideoIdentityCell({
  identity,
  secondaryAction,
}: {
  readonly identity: VideoIdentity;
  readonly secondaryAction?: ReactNode;
}) {
  const [thumbnailFailed, setThumbnailFailed] = useState(false);
  const label = videoLabel({
    adCount: identity.adCount,
    brandId: identity.brandId,
    displayAdName: identity.displayAdName,
    lengthSeconds: identity.lengthSeconds,
    videoId: identity.videoId,
  });

  return (
    <div
      aria-label={label.accessible}
      className="video-identity"
      data-testid={`video-identity-${identity.videoId}`}
    >
      {identity.thumbnailUrl && !thumbnailFailed ? (
        <img
          alt=""
          className="video-identity__thumbnail"
          onError={() => setThumbnailFailed(true)}
          src={identity.thumbnailUrl}
        />
      ) : (
        <span
          aria-label="Thumbnail unavailable"
          className="video-identity__thumbnail-fallback"
          role="img"
        >
          ▶
        </span>
      )}
      <span className="video-identity__text">
        <span className="video-identity__primary" title={label.primary}>
          {label.primary}
        </span>
        <span className="video-identity__secondary-row">
          <span className="video-identity__secondary">{label.secondary}</span>
          {secondaryAction ? (
            <span className="video-identity__secondary-action">{secondaryAction}</span>
          ) : null}
        </span>
      </span>
    </div>
  );
}
